
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import 'react';
import { thumbnailContainer } from './styles.js';
import { createElement as jsx } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var Thumbnail = function Thumbnail(props) {
  return jsx("img", _extends({
    css: thumbnailContainer
  }, props));
};

export { Thumbnail as default };
//# sourceMappingURL=Thumbnail.js.map
